(function() {
    let tlFreeGiftOfferClone;
    
    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if (val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val;
                val.detectCartData = async () => {
                    try {
                        const cartData = await window.tlFreeGiftOffer.ajaxApi.cartGet();

                        const itemsInCart = new Map();
                        const ruleIdMapGifts = new Map();
                        if(cartData.items.length){
                            const validItem = cartData.items.find(item => !isNaN(item.price / item.presentment_price));
                            const ratio = validItem ? validItem.price / validItem.presentment_price : 1;

                            for (let i = 0; i < cartData.items.length; i++) {
                                const item = cartData.items[i];
                                const itemKey = item.key;
                                const itemId = String(item.id);
                                const productId = String(item.product_id);
            
                                const appliedRuleId = window.tlFreeGiftOffer.checkLineItemIsGift(item);

                                // If `appliedRuleId` is valid, the item is a gift
                                if(appliedRuleId){
                                    const giftsOfRule = ruleIdMapGifts.get(appliedRuleId) ?? [];
                                    ruleIdMapGifts.set(appliedRuleId, [...giftsOfRule, {
                                        id: itemId,
                                        key: itemKey,
                                        quantity: item.quantity,
                                        price: item.price / ratio,
                                        discounted_price: item.discounted_price / ratio // thêm field này
                                    }])
                                } else if(!window.tlFreeGiftOffer.utils.isOtherModuleGift(item)) {
                                    itemsInCart.set(itemKey, {
                                        id: itemId,
                                        price: item.price / ratio,
                                        discounted_price: item.discounted_price / ratio, // thêm field này
                                        quantity: item.quantity,
                                        title: item.title,
                                        image: item.image,
                                        productId: productId,
                                        selling_plan: !!item.selling_plan_allocation
                                    })
                                }
                            }
                        }

                        window.tlFreeGiftOffer.itemsInCart = new Map(itemsInCart);
                        window.tlFreeGiftOffer.ruleIdMapGifts = new Map(ruleIdMapGifts);
                        //Clear temp cart
                        window.tlFreeGiftOffer.itemsInTempCart.clear();
                        window.tlFreeGiftOffer.ruleIdMapGiftsInTempCart.clear();

                        // Offer 25385 is auto-added and auto-removed as the discounted
                        // cart crosses its €160 threshold. Keep its claim state aligned
                        // with the persisted cart so a removed gift can be re-evaluated.
                        const backpackRuleId = 25385;
                        const backpackGiftIsInCart =
                            ruleIdMapGifts.has(backpackRuleId) ||
                            ruleIdMapGifts.has(String(backpackRuleId));

                        if (!backpackGiftIsInCart) {
                            for (const ruleId of [backpackRuleId, String(backpackRuleId)]) {
                                const ruleState = window.tlFreeGiftOffer.ruleIdMapState.get(ruleId);
                                if (ruleState?.claimedCount > 0) {
                                    window.tlFreeGiftOffer.ruleIdMapState.delete(ruleId);
                                }
                            }
                        }
                    } catch (error) {
                        console.log("Error when detectCartData: ", error);
                    }
                }

                val.getCustomerBuy = async (rule) => {
                    // Get a function to check if a cart item matches the rule's "apply_to_product" setting
                    const checkApllyTo = window.tlFreeGiftOffer.makeApplyToChecker(rule);

                    const parentInCart = [];
                    let totalProductApplied = 0;
                    let numberProductApplied = 0;

                    // Iterate through cart items to calculate totals for the rule
                    const items = window.tlFreeGiftOffer.getItems(rule);
                    for (let i = 0; i < items.length; i++) {
                        const [key, itemData] = items[i];
                        if(await checkApllyTo(itemData) && window.tlFreeGiftOffer.checkPurchaseType(itemData, rule.purchase_type)){
                            numberProductApplied += itemData.quantity;
                            totalProductApplied += itemData.discounted_price * itemData.quantity; // tính theo discounted price thay vì price

                            parentInCart.push({key, ...itemData})
                        }
                    }
                    
                    return {parentInCart, totalProductApplied, numberProductApplied}
                }
            }
        },
        configurable: true
    });
})();
